import { render, staticRenderFns } from "./OrganisationListItem.vue?vue&type=template&id=893f0400"
import script from "./OrganisationListItem.vue?vue&type=script&lang=js"
export * from "./OrganisationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('893f0400')) {
      api.createRecord('893f0400', component.options)
    } else {
      api.reload('893f0400', component.options)
    }
    module.hot.accept("./OrganisationListItem.vue?vue&type=template&id=893f0400", function () {
      api.rerender('893f0400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/OrganisationListItem.vue"
export default component.exports